<template>
    <div class="main lancamento-frequencia">

        <c-panel>
            <div v-if="carregandoInit" class="u-text-center" style="min-height: 90px;">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" @submit.native.prevent="buscar()">
                <el-alert v-if="dados.somente_consulta" type="info" :closable="false" show-icon class="u-mb-10"
                    title="Ano letivo diferente do corrente: somente consulta."></el-alert>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="4">
                        <el-form-item label="Ano letivo">
                            <el-select :value="anoLetivo" placeholder="Ano letivo" style="width: 100%" @change="trocarAnoLetivo">
                                <el-option v-for="item in $store.state.periodos" :key="item.id" :label="item.nome" :value="Number(item.id)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="precisaEscolherInstituicao" :xs="24" :sm="18" :md="20">
                        <el-form-item label="Instituição">
                            <el-select :value="instituicaoId" filterable placeholder="Selecione a instituição" style="width: 100%" @change="trocarInstituicao">
                                <el-option v-for="item in $store.state.instituicoes" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="10">
                        <el-form-item label="Turma">
                            <el-select :value="filtro.turma" filterable placeholder="Selecione a turma" style="width: 100%" @change="(v) => trocarFiltro('turma', v)">
                                <el-option v-for="turma in turmasVisiveis" :key="turma.id"
                                    :label="`${String(turma.nome || '').toUpperCase()}${turma.fase_diario == 5 ? ' (ENCERRADO)' : ''}`" :value="turma.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="7">
                        <el-form-item label="Disciplina">
                            <el-select :value="filtro.disciplina" placeholder="Selecione a disciplina" style="width: 100%"
                                :disabled="!turmaSelecionada || (disciplinas.length <= 1 && turmaSelecionada.frequencia_geral)"
                                @change="(v) => trocarFiltro('disciplina', v)">
                                <el-option v-for="d in disciplinas" :key="d.id" :label="d.nome" :value="d.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="7">
                        <el-form-item label="Período">
                            <el-select :value="filtro.periodo" placeholder="Selecione o período" style="width: 100%"
                                :disabled="!filtro.disciplina" @change="(v) => trocarFiltro('periodo', v)">
                                <el-option v-for="p in periodos" :key="p.periodo" :value="p.periodo"
                                    :label="`${p.nome}${!p.aberto ? ' (somente leitura)' : ''}`">
                                    <span>{{ p.nome }}</span>
                                    <span v-if="!p.aberto" class="lf-opcao-info"> (somente leitura)</span>
                                    <span v-else-if="!periodoLancado(p)" class="lf-opcao-pendente">pendente</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button type="primary" native-type="submit" :disabled="!filtrosCompletos" :loading="carregandoLancamento">Buscar</el-button>
                        <el-button @click="limpar()">Limpar</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>

        <c-panel v-if="carregandoLancamento">
            <div class="u-text-center" style="min-height: 90px;">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <c-panel v-else-if="lancamento">

            <el-alert v-if="lancamento.somente_leitura" type="info" :closable="false" show-icon class="u-mb-10"
                :title="lancamento.motivo_somente_leitura || 'Somente leitura.'"></el-alert>
            <el-alert v-if="lancamento.aviso" type="warning" :closable="false" show-icon class="u-mb-10" :title="lancamento.aviso"></el-alert>

            <div class="lf-ultimo">
                <template v-if="lancamento.lancamento">
                    Último lançamento: <b>{{ lancamento.lancamento.atualizado_por || '—' }}</b>
                    em {{ formatarDataHora(lancamento.lancamento.atualizado_em) }}
                </template>
                <template v-else>Ainda não lançado.</template>
            </div>

            <tabela-alunos
                :alunos="form.alunos"
                :anteriores="form.anteriores"
                :aulas-dadas="form.aulas_dadas"
                :motivos="dados.motivos_ac || []"
                :erros="erros"
                :somente-leitura="lancamento.somente_leitura"
                :frequencia-minima="dados.frequencia_minima_percentual || 75" />

            <div class="lf-rodape">
                <div class="lf-rodape-campos">
                    <label>
                        Aulas previstas
                        <integer-input :value="lancamento.lancamento ? lancamento.lancamento.aulas_previstas : ''" disabled />
                    </label>
                    <label>
                        Aulas dadas
                        <integer-input ref="inputAulasDadas" v-model="form.aulas_dadas" :max="999"
                            :disabled="lancamento.somente_leitura" :erro="!!erroAulasDadas" />
                    </label>
                </div>
                <div class="lf-erro" v-if="erroAulasDadas">{{ erroAulasDadas }}</div>
                <div class="lf-rodape-botoes">
                    <el-button @click="voltar()">Voltar</el-button>
                    <el-button v-if="!lancamento.somente_leitura" type="primary" :loading="salvando" @click="salvar()">Salvar</el-button>
                </div>
            </div>
        </c-panel>

    </div>
</template>

<script>
// Lançamento de frequência por período (bimestre) no web admin — spec_diario/frequencias/04.
// Turma → disciplina → período; faltas, aulas compensadas (A.C) e motivo por aluno; aulas dadas no rodapé.
// Mesma API do diário eletrônico (api/frequencia-periodo/*).
import IntegerInput from '@/shared/integer-input'
import TabelaAlunos from './tabela-alunos.vue'

export default {
    components: { IntegerInput, TabelaAlunos },
    data () {
        return {
            carregandoInit: false,
            carregandoLancamento: false,
            salvando: false,
            instituicaoEscolhida: '',
            // Ano letivo da consulta; fora do corrente a API devolve tudo somente leitura.
            anoLetivo: Number(this.$store.state.config.parametros.periodo_letivo_situacao_academica) || '',
            dados: { turmas: [], motivos_ac: [] },
            filtro: { turma: '', disciplina: '', periodo: '' },
            lancamento: null,
            form: { aulas_dadas: '', alunos: [], anteriores: [] },
            original: '',
            erros: {},
            erroAulasDadas: ''
        }
    },
    computed: {
        // Secretaria/direção/coordenação/professor usam a instituição escolhida no login; SMED/NTI escolhem aqui.
        precisaEscolherInstituicao () {
            return !this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id
        },
        instituicaoId () {
            return this.precisaEscolherInstituicao ? this.instituicaoEscolhida : this.$store.state.config.instituicao.id
        },
        // Professor vê só as turmas em que leciona; direção, coordenação, secretaria e SMED veem todas.
        turmasVisiveis () {
            if (this.$store.state.user.tipo == 2) {
                return this.dados.turmas.filter(t => t.minha_turma)
            }
            return this.dados.turmas
        },
        turmaSelecionada () {
            return this.dados.turmas.find(t => t.id == this.filtro.turma) || null
        },
        disciplinas () {
            return this.turmaSelecionada ? this.turmaSelecionada.disciplinas : []
        },
        periodos () {
            return this.turmaSelecionada ? this.turmaSelecionada.periodos : []
        },
        filtrosCompletos () {
            return !!(this.filtro.turma && this.filtro.disciplina && this.filtro.periodo)
        },
        alterado () {
            return !!this.lancamento && !this.lancamento.somente_leitura && this.estadoAtual() !== this.original
        }
    },
    async mounted () {
        const q = this.$route.query
        if (this.precisaEscolherInstituicao && q.instituicao) this.instituicaoEscolhida = Number(q.instituicao)
        if (q.ano) this.anoLetivo = Number(q.ano)

        if (!this.instituicaoId) return

        await this.carregarInit()

        if (q.turma && this.turmasVisiveis.find(t => t.id == q.turma)) {
            this.filtro.turma = Number(q.turma)
            if (q.disciplina && this.disciplinas.find(d => d.id == q.disciplina)) this.filtro.disciplina = String(q.disciplina)
            else this.preSelecionarDisciplina()
            if (q.periodo && this.periodos.find(p => p.periodo == q.periodo)) this.filtro.periodo = Number(q.periodo)
            if (this.filtrosCompletos) this.buscar()
        } else if (this.turmasVisiveis.length == 1) {
            this.aplicarFiltro('turma', this.turmasVisiveis[0].id)
        }
    },
    async beforeRouteLeave (to, from, next) {
        next(await this.confirmarDescarte())
    },
    methods: {
        estadoAtual () {
            return JSON.stringify({
                a: this.form.aulas_dadas,
                l: this.form.alunos.map(x => [x.faltas, x.aulas_compensadas, x.motivo_aula_compensada_id])
            })
        },
        periodoLancado (p) {
            return !!(p.lancado && this.filtro.disciplina && p.lancado[this.filtro.disciplina])
        },
        async carregarInit () {
            this.carregandoInit = true
            try {
                const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/frequencia-periodo/init/${this.instituicaoId}${this.anoLetivo ? `?periodo_letivo_id=${this.anoLetivo}` : ''}`, this.$store.getters.getHeaderAuth)
                if (res.data && res.data.erro) {
                    window.eventBus.$emit('alert', { msg: res.data.erro.text || res.data.erro, type: 'warning' })
                    return
                }
                this.dados = res.data
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.carregandoInit = false
            }
        },
        async confirmarDescarte () {
            if (!this.alterado) return true
            try {
                await this.$confirm('Há alterações não salvas. Descartar?', 'Atenção', { confirmButtonText: 'Descartar', cancelButtonText: 'Continuar editando', type: 'warning' })
                return true
            } catch (e) {
                return false
            }
        },
        async trocarInstituicao (v) {
            if (!(await this.confirmarDescarte())) return
            this.instituicaoEscolhida = v
            this.filtro = { turma: '', disciplina: '', periodo: '' }
            this.lancamento = null
            this.atualizarQuery()
            await this.carregarInit()
        },
        async trocarAnoLetivo (v) {
            if (v === this.anoLetivo) return
            if (!(await this.confirmarDescarte())) return
            this.anoLetivo = v
            this.filtro = { turma: '', disciplina: '', periodo: '' }
            this.lancamento = null
            this.atualizarQuery()
            if (this.instituicaoId) await this.carregarInit()
        },
        async trocarFiltro (campo, valor) {
            if (valor === this.filtro[campo]) return
            if (!(await this.confirmarDescarte())) return
            this.aplicarFiltro(campo, valor)
        },
        aplicarFiltro (campo, valor) {
            this.filtro[campo] = valor
            this.lancamento = null

            if (campo == 'turma') {
                this.filtro.disciplina = ''
                this.preSelecionarDisciplina()
            }
            if (campo == 'turma' || campo == 'disciplina') {
                this.filtro.periodo = ''
            }

            this.atualizarQuery()
            if (this.filtrosCompletos) this.buscar()
        },
        preSelecionarDisciplina () {
            if (this.disciplinas.length == 1) this.filtro.disciplina = this.disciplinas[0].id
        },
        atualizarQuery () {
            const query = {}
            if (this.precisaEscolherInstituicao && this.instituicaoEscolhida) query.instituicao = this.instituicaoEscolhida
            if (this.anoLetivo && this.anoLetivo != this.$store.state.config.parametros.periodo_letivo_situacao_academica) query.ano = this.anoLetivo
            if (this.filtro.turma) query.turma = this.filtro.turma
            if (this.filtro.disciplina) query.disciplina = this.filtro.disciplina
            if (this.filtro.periodo) query.periodo = this.filtro.periodo
            if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) this.$router.replace({ query }).catch(() => {})
        },
        async limpar (semConfirmar = false) {
            if (!semConfirmar && !(await this.confirmarDescarte())) return
            this.filtro = { turma: '', disciplina: '', periodo: '' }
            this.lancamento = null
            this.erros = {}
            this.erroAulasDadas = ''
            this.atualizarQuery()
        },
        async buscar () {
            if (!this.filtrosCompletos) return

            this.carregandoLancamento = true
            this.erros = {}
            this.erroAulasDadas = ''

            try {
                const payload = { turma_id: this.filtro.turma, disciplina: this.filtro.disciplina, periodo: this.filtro.periodo }
                const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia-periodo/getLancamento`, payload, this.$store.getters.getHeaderAuth)

                if (res.data && res.data.erro) {
                    this.lancamento = null
                    window.eventBus.$emit('alert', { msg: res.data.erro.text || res.data.erro, type: 'warning' })
                    return
                }

                this.lancamento = res.data
                this.form = {
                    aulas_dadas: res.data.lancamento ? res.data.lancamento.aulas_dadas : '',
                    alunos: res.data.alunos.map(a => ({ ...a })),
                    anteriores: res.data.matriculas_anteriores || []
                }
                this.original = this.estadoAtual()
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.carregandoLancamento = false
            }
        },
        // Mesmas regras do servidor (spec_diario/frequencias/01 §5), para marcar as linhas antes de enviar.
        validar () {
            const errosLocais = {}
            this.erroAulasDadas = ''

            const aulas = this.form.aulas_dadas === '' ? null : Number(this.form.aulas_dadas)
            if (!aulas || aulas < 1) this.erroAulasDadas = 'Informe a quantidade de aulas dadas.'

            for (const a of this.form.alunos) {
                const faltas = a.faltas === '' ? 0 : Number(a.faltas)
                const ac = a.aulas_compensadas === '' ? 0 : Number(a.aulas_compensadas)

                if (aulas && faltas > aulas) {
                    errosLocais[a.aluno_id] = { campo: 'faltas', mensagem: 'Faltas maiores que as aulas dadas.' }
                } else if (ac > faltas) {
                    errosLocais[a.aluno_id] = { campo: 'aulas_compensadas', mensagem: 'A.C maior que as faltas.' }
                } else if (ac > 0 && !a.motivo_aula_compensada_id) {
                    errosLocais[a.aluno_id] = { campo: 'motivo_aula_compensada_id', mensagem: 'Informe o motivo da A.C.' }
                }
            }

            this.erros = errosLocais
            return !this.erroAulasDadas && !Object.keys(errosLocais).length
        },
        async salvar () {
            if (!this.validar()) {
                if (this.erroAulasDadas && this.$refs.inputAulasDadas) this.$refs.inputAulasDadas.focus()
                window.eventBus.$emit('alert', { msg: 'Corrija os campos destacados antes de salvar.', type: 'warning' })
                return
            }

            this.salvando = true
            window.eventBus.$emit('loading', true)

            try {
                const payload = {
                    turma_id: this.filtro.turma,
                    disciplina: this.filtro.disciplina,
                    periodo: this.filtro.periodo,
                    aulas_dadas: Number(this.form.aulas_dadas),
                    alunos: this.form.alunos.map(a => ({
                        frequencia_id: a.frequencia_id,
                        aluno_id: a.aluno_id,
                        faltas: a.faltas === '' ? 0 : Number(a.faltas),
                        aulas_compensadas: a.aulas_compensadas === '' ? 0 : Number(a.aulas_compensadas),
                        motivo_aula_compensada_id: Number(a.aulas_compensadas) > 0 ? a.motivo_aula_compensada_id : null
                    }))
                }

                const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia-periodo/store`, payload, this.$store.getters.getHeaderAuth)

                if (res.data && res.data.erro) {
                    const erro = res.data.erro
                    if (erro.alunos) {
                        const mapa = {}
                        for (const e of erro.alunos) mapa[e.aluno_id] = { campo: e.campo, mensagem: e.mensagem }
                        this.erros = mapa
                    }
                    window.eventBus.$emit('alert', { msg: erro.text || erro, type: 'warning' })
                    return
                }

                window.eventBus.$emit('alert', { msg: res.data.mensagem || 'Frequência salva.', type: 'success' })

                const p = this.periodos.find(x => x.periodo == this.filtro.periodo)
                if (p) this.$set(p, 'lancado', { ...(p.lancado || {}), [this.filtro.disciplina]: true })
                await this.buscar()
            } catch (e) {
                this.$store.commit('throwException', e)
            } finally {
                this.salvando = false
                window.eventBus.$emit('loading', false)
            }
        },
        voltar () {
            this.$router.push('/admin')
        },
        formatarDataHora (d) {
            return d ? this.$moment(d).format('DD/MM/YYYY HH:mm') : ''
        }
    }
}
</script>

<style>
    .lancamento-frequencia .lf-ultimo {
        font-size: 13px;
        color: #606266;
        margin-bottom: 8px;
    }
    .lancamento-frequencia .lf-rodape {
        margin-top: 15px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        justify-content: space-between;
    }
    .lancamento-frequencia .lf-rodape-campos label {
        font-size: 13px;
        font-weight: 600;
        color: #303133;
        margin-right: 20px;
    }
    .lancamento-frequencia .lf-erro {
        width: 100%;
        color: #f56c6c;
        font-size: 12px;
    }
    .lf-opcao-info {
        color: #909399;
        font-size: 12px;
    }
    .lf-opcao-pendente {
        color: #e6a23c;
        font-size: 12px;
        margin-left: 6px;
    }
</style>
